import React from "react";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";
import UserModel from "app/models/UserModel";
import styles from "./styles.module.scss";

// Renders a "Managed by <guardian names>" sub-line for a managed child — a user
// that carries family guardians (backend include[]=guardians). Renders nothing
// for everyone else. The name stays fully visible even inside rows that
// truncate their <p> children.
const ManagedByNote = ({
  user,
  className,
}: {
  user: { guardians?: UserModel[] };
  className?: string;
}) => {
  const { t } = useTranslation();
  const guardians = user.guardians ?? [];

  if (guardians.length === 0) {
    return null;
  }

  const names = guardians
    .map(
      (guardian) =>
        guardian.displayName ||
        guardian.name ||
        [guardian.firstName, guardian.lastName].filter(Boolean).join(" ")
    )
    .join(", ");

  return (
    <p className={cls(styles.managed_by, className)}>
      <span>{t("Managed by")} <strong>{names}</strong></span>
    </p>
  );
};

export default ManagedByNote;
